export default __webpack_public_path__ + "static/experienceImg1-b4fefdb6b6794221ad4700d480205548.webp";